import { useCallback, useEffect, useRef } from 'react';

const usePushNotifications = () => {
    const registrationRef = useRef<Promise<ServiceWorkerRegistration> | null>(null);

    useEffect(() => {
        if (!('serviceWorker' in navigator)) return;

        (async () => {
            if (!registrationRef.current) {
                registrationRef.current = navigator.serviceWorker
                    .register(`${process.env.PUBLIC_URL}/sw.js`)
                    .catch((err) => {
                        console.error('Service worker registration failed', err);
                        throw err;
                    });
            }

            if (Notification.permission === 'default') {
                await Notification.requestPermission();
            }
        })();
    }, []);

    const sendLocalNotification = useCallback(
        async (title: string, body: string, url?: string) => {
            if (!('serviceWorker' in navigator)) return;

            const permission =
                Notification.permission === 'default'
                    ? await Notification.requestPermission()
                    : Notification.permission;

            if (permission === 'granted') {
                const reg = registrationRef.current
                    ? await registrationRef.current
                    : await navigator.serviceWorker.ready;

                await reg.showNotification(title, {
                    body,
                    data: { url },
                });
            }
        },
        []
    );

    return { sendLocalNotification };
};

export default usePushNotifications;
